<template>
  <div>
    <p class="text-2xl mb-6">
      {{
        editing
          ? `Editer le mapping (${selected.source}) : ${selected.search} => ${selected.replace}`
          : "Créer un nouveau mapping"
      }}
    </p>
    <v-card class="pt-7 pb-3">
      <v-row class="ma-3">
        <v-card-text>
          <v-form ref="myForm">
            <v-row>
              <v-col cols="12" sm="8">
                <v-select
                  outlined
                  v-model="selected.entity"
                  :items="page.entities"
                  :menu-props="{ maxHeight: '400', zIndex: 13 }"
                  label="Entité"
                  item-text="name"
                  item-value="id"
                  :rules="[required]"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="8">
                <v-select
                  outlined
                  v-model="selected.source"
                  :items="page.sources"
                  :menu-props="{ maxHeight: '400', zIndex: 13 }"
                  label="Source"
                  item-text="name"
                  item-value="id"
                  :rules="[required]"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="8">
                <div class="mb-4 d-flex align-center">
                  <v-text-field
                    outlined
                    v-model="selected.search"
                    dense
                    label="Valeur CSV"
                    :rules="[required]"
                  ></v-text-field>
                </div>
              </v-col>

              <v-col cols="12" sm="8">
                <div class="mb-4 d-flex align-center">
                  <v-text-field
                    outlined
                    v-model="selected.replace"
                    dense
                    label="Valeur RMR"
                    :rules="[required]"
                  ></v-text-field>
                </div>
              </v-col>

              <v-col cols="12">
                <v-btn
                  color="primary"
                  class="me-3 mt-3"
                  @click.native="saveMapping"
                >
                  Enregistrer le mapping</v-btn
                >
                <v-btn
                  color="secondary"
                  outlined
                  class="mt-3"
                  :to="{ name: 'finance-list-mapping' }"
                >
                  Annuler
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { required } from "@core/utils/validation";
import { onMounted, reactive, ref, set } from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

const COMPONENT_NAME = "FinanceMappingReplaceFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { route, router } = useProxy();
    const { axiosGet, axiosPost, axiosPut } = useAxios();

    const myForm = ref(null);
    const editing = ref(false);

    const page = reactive({
      loading: false,
      entities: [],
      sources: [],
    });

    const selected = reactive({
      id: 0,
      entity: "",
      source: "",
      search: "",
      replace: "",
    });

    // =>  METHODS
    const saveMapping = async () => {
      if (!myForm.value.validate()) {
        return;
      }

      if (editing.value) {
        const { status } = await axiosPut("/finance/mapping", selected);
        if (status === 200) {
          await router.push({ name: "finance-list-mapping" });
        }
      } else {
        const { status } = await axiosPost("/finance/mapping", selected);
        if (status === 200) {
          await router.push({ name: "finance-list-mapping" });
        }
      }
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      if ("id" in route.params && route.params.id) {
        editing.value = true;

        const { data } = await axiosGet("/finance/mapping", {
          id: route.params.id,
        });

        for (const [key, value] of Object.entries(data)) {
          set(selected, key, value);
        }
      }

      const { data: entities } = await axiosGet("/finance/mapping/entities");
      set(
        page,
        "entities",
        Object.entries(entities).map(([key, value]) => ({
          id: key,
          name: value,
        }))
      );

      const { data: sources } = await axiosGet("/finance/mapping/sources");
      set(
        page,
        "sources",
        Object.entries(sources).map(([key, value]) => ({
          id: key,
          name: value,
        }))
      );
    });

    // =>  DATA
    return {
      page,
      myForm,
      selected,
      required,
      editing,
      saveMapping,
    };
  },
};
</script>

<style></style>
